import { gql } from '@apollo/client'

import { LOCATION_FRAGMENT } from './LocationFragment'

export const STORE_FRAGMENT = gql`
  fragment Store on Store {
    id
    externalStoreId
    inactiveAt
    hasRecentHeartbeat
    lastHeartbeatTimestamp
    clientVersion
    hasErrorsOnLatestHeartbeat
    recentErrors {
      id
      errorTimestamp
      component
      message
      severity
    }
    recentErrorsGrouped {
      component
      normalizedMessage
      sampleMessage
      firstOccurrence
      lastOccurrence
      count
      errorIds
      severity
    }
    location {
      ...Location
    }
    users {
      id
      isActive
    }
  }
  ${LOCATION_FRAGMENT}
`
